(() => {
  const storageKey = 'everword-color-mode';
  const root = document.documentElement;
  const media = window.matchMedia('(prefers-color-scheme: dark)');

  const savedMode = () => {
    try {
      const value = localStorage.getItem(storageKey);
      return value === 'light' || value === 'dark' ? value : null;
    } catch (error) {
      return null;
    }
  };

  const systemMode = () => media.matches ? 'dark' : 'light';

  const render = (mode) => {
    root.dataset.theme = mode;
    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      const isDark = mode === 'dark';
      button.setAttribute('aria-pressed', String(isDark));
      const label = isDark ? 'Use light theme' : 'Use dark theme';
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
    });
  };

  render(savedMode() || systemMode());

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-theme-toggle]');
    if (!button) return;
    const nextMode = root.dataset.theme === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem(storageKey, nextMode); } catch (error) {}
    render(nextMode);
  });

  media.addEventListener?.('change', () => {
    if (!savedMode()) render(systemMode());
  });
})();